import AppColors from './colors';

const StylesInput = {
  inputErrorText: {
    color: '#ff6262 !important',
    fontSize: '12px !important',
    textAlign: 'right !important',
    bottom: '5px !important',
  },

  customInputDisabled: {
    cursor: 'none',
    backgroundColor: '#676a86',
    color: '#696979',
    pointerEvents: 'none',
  },

  customInput: {
    color: AppColors.neutralGrey[1],
    textAlign: 'right',
  },

  customInputBlue: {
    width: 'calc(100%)',
    border: '1px solid white',
    borderRadius: '10px',
    padding: '1rem',
    backgroundColor: AppColors._Inputs.inputBgBlue,
  },

  customInputValue: {
    color: AppColors.neutralGrey[1] + '!important',
    textAlign: 'right !important',
    fontWeight: '600 !important',
    fontSize: '24px !important',
    padding: '0 !important',
  },

  customInputValueDisabled: {
    color: 'rgb(63, 64, 77)',
    textAlign: 'right',
    fontWeight: '600',
    fontSize: '24px',
    padding: '0',
  },

  selectable: {
    WebkitTouchCallout: 'default !important',
    WebkitUserSelect: 'text !important',
    MozUserSelect: 'text !important',
    msUserSelect: 'text !important',
    userSelect: 'text !important',
  },
};

export default StylesInput;
